import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CharacterCountPipe } from './CharacterCountPipe';
import { ContactsFilterPipe } from './contactsFilter.pipe';
import { DateFilterPipe } from './date-filter.pipe';
import { SafeUrlPipe } from './SafeUrl.pipe';
import { SanitizerPipe } from './sanitizer.pipe';
import { AumnicsDatePipePipe } from './aumnics-date-pipe.pipe';
import { AumnicsDatePipeShortFormatPipe } from './aumnics-date-pipe-short-format.pipe';
import { AumnicsMMMDdYyyyFormatPipe } from './aumnics-mmm-dd-yyyy-format.pipe';
import { AumnicsMmmDDatePipe } from './aumnics-mmm-d-date.pipe';
import { AumnicsDateTimeFormatPipe } from './aumnics-date-time-format.pipe';
import { CharacterCountingPipe } from './CharacterCountingPipe';
import { HumanReadableDatePipe } from './human-readable-date.pipe';
import { HumanReadableShortDatePipe } from './human-readable-short-date-format.pipe';
import { AumnicsMMMDDYYFormatPipe } from './aumnics-mmm-dd-yyyy.pipe';
import { AmyTaskManagerDatePipe } from './amy-task-manager-date-pipe';
import { TruncatePipe } from './title-truncate';
import { timeEntryDaysDuration } from './timeEntryDaysDuration.pipe';
import { SpacesFilterPipe } from './space-project-filter.pipe';
import { TimeFormatterPipe } from './time-formatter.pipe';

@NgModule({
    declarations: [
        DateFilterPipe,
        ContactsFilterPipe,
        SpacesFilterPipe,
        CharacterCountPipe,
        SanitizerPipe,
        SafeUrlPipe,
        AumnicsDatePipePipe,
        AumnicsDatePipeShortFormatPipe,
        AumnicsMMMDdYyyyFormatPipe,
        AumnicsMmmDDatePipe,
        AumnicsDateTimeFormatPipe,
        CharacterCountingPipe,
        HumanReadableDatePipe,
        HumanReadableShortDatePipe,
        AumnicsMMMDDYYFormatPipe,
        AmyTaskManagerDatePipe,
        TruncatePipe,
        timeEntryDaysDuration,
        TimeFormatterPipe
    ],
    imports: [CommonModule],
    exports: [
        DateFilterPipe,
        ContactsFilterPipe,
        CharacterCountPipe,
        SanitizerPipe,
        SafeUrlPipe,
        AumnicsDatePipePipe,
        AumnicsDatePipeShortFormatPipe,
        AumnicsMMMDdYyyyFormatPipe,
        AumnicsMMMDDYYFormatPipe,
        AumnicsMmmDDatePipe,
        AumnicsDateTimeFormatPipe,
        CharacterCountingPipe,
        HumanReadableDatePipe,
        HumanReadableShortDatePipe,
        AmyTaskManagerDatePipe,
        TruncatePipe,
        timeEntryDaysDuration,
        SpacesFilterPipe,
        TimeFormatterPipe

    ]
})
export class PipesModule { }
